import { type MutationError, trpc } from '@/shared/api';

interface UseSetPrintMethodsOptions {
  readonly onSuccess?: () => void;
}

/** 지원 인쇄 방식 저장. */
export const useSetPrintMethods = ({ onSuccess }: UseSetPrintMethodsOptions = {}) => {
  const mutation = trpc.productManagement.products.setPrintMethods.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setPrintMethods: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
